import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1420.81129,1342.11624 C1450.74071,1297.39153 1468.24659,1243.63153 1468.24659,1185.91859 C1468.24659,1049.59859 1371.11718,935.528 1242.36424,909.325647 L1242.36424,1169.99388 L1420.81129,1342.11624 Z M903.540706,1185.91859 C903.540706,1341.66447 1030.14776,1468.27153 1185.89365,1468.27153 C1243.04188,1468.27153 1296.12424,1450.99153 1340.62306,1421.62682 L1129.42306,1217.99388 L1129.42306,909.325647 C1000.67012,935.528 903.540706,1049.59859 903.540706,1185.91859 Z M1185.89365,790.624471 C1403.87012,790.624471 1581.18776,967.942118 1581.18776,1185.91859 C1581.18776,1403.89506 1403.87012,1581.21271 1185.89365,1581.21271 C967.917176,1581.21271 790.599529,1403.89506 790.599529,1185.91859 C790.599529,967.942118 967.917176,790.624471 1185.89365,790.624471 Z M1355.29412,225.941176 L1355.29412,677.705882 L1807.05882,677.705882 L1807.05882,1694.17647 L112.941176,1694.17647 L112.941176,225.941176 L1355.29412,225.941176 Z M677.647059,677.705882 L338.823529,677.705882 L338.823529,790.647059 L677.647059,790.647059 L677.647059,677.705882 Z M1016.47059,451.823529 L1016.47059,564.764706 L338.823529,564.764706 L338.823529,451.823529 L1016.47059,451.823529 Z M1468.23529,249.32 L1783.68,564.764706 L1468.23529,564.764706 L1468.23529,249.32 Z M1870.41882,491.804706 L1541.19529,162.581176 C1509.68471,131.070588 1465.97647,113 1421.47765,113 L0,113 L0,1807.11765 L1920,1807.11765 L1920,611.522353 C1920,566.345882 1902.38118,523.767059 1870.41882,491.804706 L1870.41882,491.804706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMsPptLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMsPptLine, _Component);

  var _super = _createSuper(IconMsPptLine);

  function IconMsPptLine() {
    _classCallCheck(this, IconMsPptLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMsPptLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMsPpt",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMsPptLine.displayName = "IconMsPptLine";
  return IconMsPptLine;
}(Component);

IconMsPptLine.glyphName = 'ms-ppt';
IconMsPptLine.variant = 'Line';
IconMsPptLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMsPptLine;
export { IconMsPptLine };